import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { Situations } from "./components/sections/Situations";
import { Volumes } from "./components/sections/Volumes";
import { Tools } from "./components/sections/Tools";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Testimonials } from "./components/sections/Testimonials";
import { Author } from "./components/sections/Author";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans" data-id="element-0" data-mp="23t8heerpojdg">
      <MetaPixel data-id="element-1" data-mp="3ijfx0558q6h9" />
      <Hero data-id="element-2" data-mp="3ihv22ef0kliv" />
      <main data-id="element-3" data-mp="3ii4qvyobommz">
        <BeforeAfter data-id="element-4" data-mp="3mlawr57iwbsx" />
        <Situations data-id="element-5" data-mp="3mkrc3gqhn9b7" />
        <Volumes data-id="element-6" data-mp="3mk83iqmq9x9u" />
        <Tools data-id="element-7" data-mp="3mjpyb4i388ps" />
        <Bonuses data-id="element-8" data-mp="3mj6j3vjtnyfg" />
        <Offer data-id="element-9" data-mp="3rcj8i7wbs999" />
        <Guarantee data-id="element-10" data-mp="3rbzomln47asl" />
        <Testimonials data-id="element-11" data-mp="3rdkh85pvcjnt" />
        <Author data-id="element-12" data-mp="3recf5n6xuth9" />
        <Faq data-id="element-13" data-mp="5yk6vxnnffx" />
        <FinalCta data-id="element-14" data-mp="5orv1p50w72" />
      </main>
      <Footer data-id="element-15" data-mp="4wylxj0jajy" />
      <FloatingCta anchorId="hero-cta" data-id="element-16" data-mp="5ghbgghm2z1" />
      <PurchasePopup data-id="element-17" data-mp="2zl3cxocsjc6w" />
    </div>;
}